import Layout from "../components/Layout";
import React, {useEffect, useState, useRef} from 'react'
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {useDispatch, useSelector} from 'react-redux';
import {Formik } from 'formik'
import TextField from "../components/TextField";
import axios from 'axios';
import {BASE_URL} from "../utils/commonUrl";
import {ProgressSpinner} from "primereact/progressspinner";
import * as Yup from "yup";
import { Toast } from 'primereact/toast';
import {FilterMatchMode, FilterOperator} from "primereact/api";
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";

const SupervisorUpdate = () => {
    const [start] = useState(0);
    const primeToast = useRef(null)
    const {user} = useSelector((state) => state["auth"]);
    const [userInformation, setUserInformation] = useState([]);
    const [filters, setFilters] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [supervisorInformation, setSupervisorInformation] = useState({
        addedBy:"",
        registerID: 0,
        supervisorID: 0,
        employeeCode: "",
        supervisorName: "",
        department:"",
        designation:""
    })

    useEffect(() => {
        initFilters();
        GetUserInformation(user.registerID);
    }, [])

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = {...filters};
        _filters['global'].value = value;
        setFilters(_filters);
        setGlobalFilterValue(value);
    }
    const initFilters = () => {
        setFilters({
            'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
            'registerID': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'employeeCode': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'employeeName': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'department': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'designation': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            'supervisorName': {
                operator: FilterOperator.AND,
                constraints: [{value: null, matchMode: FilterMatchMode.STARTS_WITH}]
            },
            
        });
        setGlobalFilterValue('');
    }

    const clearFilter = () => {
        initFilters();
    }
    const GetUserInformation=(id)=>{
        setIsLoading(true);
        axios.get(BASE_URL + `/api/register/GetAllRegisterUsers/${id}`)
            .then(response => {
                console.log(response.data);
                setUserInformation(response.data);
                setIsLoading(false);
            })
            .catch(e => {
                console.log(e);
                setIsLoading(false);
            })
    }

    const empCodeBody = emp => {
        return <span className={"text-success"}
                     style={{cursor: "pointer"}}
                     onClick={() => {                        
                        LoadSupervisorInformation(emp.registerID);
                     }}>
            {emp.employeeName}
        </span>
    }

    const LoadSupervisorInformation=(id)=>{
        axios.get(BASE_URL + `/api/register/GetUserSupervisorName/${id}`)
            .then(response => {
                if(response.data.length > 0){
                    setSupervisorInformation({
                        addedBy: user.registerID,
                        registerID: response.data[0].registerID,
                        supervisorID: response.data[0].supervisorID,
                        employeeCode:response.data[0].employeeCode,
                        supervisorName:response.data[0].supervisorName,
                        department:response.data[0].department,
                        designation:response.data[0].designation
                    });
                }
                else{
                    setSupervisorInformation([]);
                }
                console.log(response.data);
            })
            .catch(e => {
                console.log(e)
            })
    }

    const header = (
        <div className="table-header">
            <div className='d-flex justify-content-between'>
                <div>
                    <Button type="button" icon="pi pi-filter-slash" label="Clear" className="p-button-outlined"
                            onClick={clearFilter}/>
                    <span className="p-input-icon-left"> <i className="pi pi-search"/>
                    <InputText value={globalFilterValue} onChange={onGlobalFilterChange}
                               placeholder="Keyword Search"/>
                </span>
                </div>
                {isLoading ? <ProgressSpinner style={ {height:50,width:50} }/> : ""}
            </div>
        </div>
    );

    const validation = Yup.object({
        supervisorID: Yup.number().min(1).required("This field is required")
    })

    return (<Layout>
        <Toast ref={primeToast}/>
        <div className="card">
            <div className="card-header">
               <h6><i class="bi bi-person-check-fill"></i> Update Employee Supervisor Information</h6>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-8">
                        <DataTable value={userInformation}
                           header={header}
                           resizableColumns
                           showGridlines
                           dataKey="registerID"
                           filters={filters}
                           filterDisplay="menu"
                           globalFilterFields={['registerID', 'employeeCode' ,'employeeName', 'department', 'designation','supervisorName']}
                           paginator rows={10} first={start}
                           paginatorTemplate="RowsPerPageDropdown PageLinks FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink">
                    <Column field='registerID' header="Reg. ID" sortable/>
                    <Column field='employeeCode' header="Code" sortable className="text-center"/>
                    <Column field='employeeName' header="Employee Name" sortable  body={empCodeBody}/>
                    <Column field='supervisorName' header="Supervisor Name" sortable/>
                    <Column field='department' header="Department" sortable/>
                    <Column field='designation' header="Designation" sortable/>                    
                        </DataTable>
                    </div>
                    <div className="col-4 card">
                    <div className="card-header row">
                            <h6 class="card-title"><i class="bi bi-person"></i> Supervisor Information</h6>
                        </div>
                    <div class="card-body">
                        
                    <Formik  validationSchema={validation}
                     enableReinitialize={true} 
                    initialValues={{ 
                    addedBy:supervisorInformation.addedBy.toString(),
                    registerID:supervisorInformation.registerID,
                    supervisorID: supervisorInformation.supervisorID === 0 ?"":supervisorInformation.supervisorID,
                    supervisorName: supervisorInformation.supervisorName === "" ?"":supervisorInformation.supervisorName,
                    employeeCode: supervisorInformation.employeeCode === "" ?"":supervisorInformation.employeeCode,
                    department: supervisorInformation.department === "" ? "":supervisorInformation.department,
                    designation: supervisorInformation.designation === "" ? "":supervisorInformation.designation }}
                    onSubmit={(values, actions) => {
                        const data = JSON.stringify(values, null, 2);
                        console.log(data);

                    axios.post(BASE_URL + "/api/register/UpdateSupervisorName", data)
                                .then(response => {
                                    if (response.status === 200) {
                                        LoadSupervisorInformation(supervisorInformation.registerID);
                                        primeToast.current.show({ 
                                            severity: 'success', 
                                            summary: 'success', 
                                            detail: 'Supervisor Updated Successfully..!', 
                                            life: 3000 });                                       
                                    }
                                    else{
                                        primeToast.current.show({
                                            severity: 'error',
                                            summary: 'error',
                                            detail: 'Supervisor Updated Not Completed please contact with MIS team..!',
                                            life: 3000
                                        });
                                    }
                                }).catch(e => {
                                    primeToast.current.show({
                                        severity: 'error',
                                        summary: 'error',
                                        detail: 'Supervisor Updated Not Completed please contact with MIS team..!',
                                        life: 3000
                                    });
                                })
       
       }}
     >
       {props => (
         <form onSubmit={props.handleSubmit}>
          <div className="row">
          <TextField label={'Supervisor Employee Code'} type="text" name="employeeCode"
                onChange={props.handleChange} onBlur={props.handleBlur} 
                value={props.values.employeeCode} disabled placeholder="Employee Code.."/>  

          <TextField label={'Supervisor Name'} type="text" name="supervisorName"
                onChange={props.handleChange} onBlur={props.handleBlur} 
                value={props.values.supervisorName} disabled placeholder="Supervisor Name.."/>

            <TextField label={'Department'} type="text" name="department" disabled 
                onChange={props.handleChange} onBlur={props.handleBlur}
                value={props.values.department} placeholder="Supervisor Department.."/>

            <TextField label={'Designation'} type="text" name="designation" disabled
                onChange={props.handleChange} onBlur={props.handleBlur} 
                value={props.values.designation} placeholder="Supervisor Designation.."/>

            <TextField label={'Supervisor Register ID'} type="text" name="supervisorID"  
                onChange={props.handleChange} onBlur={props.handleBlur} 
                value={props.values.supervisorID} placeholder="Enter Supervisor Register ID.."/>  

          </div>
          <div className="row">
                <div className="col-12">
                {props.errors.name && <div id="feedback">{props.errors.name}</div>}
                    <button type="submit" className="btn btn-primary"><i class="bi bi-check2-all"></i> Submit</button>
                </div>
            </div>
            <TextField label={''} type="hidden" name="registerID"  
            onChange={props.handleChange} 
            onBlur={props.handleBlur} value={props.values.registerID}/>
            
            <TextField label={''} type="hidden" name="addedBy"  
            onChange={props.handleChange} 
            onBlur={props.handleBlur} value={props.values.addedBy}/>
         </form>
       )}
            </Formik>
            </div>
                    </div>
                </div>
            </div>
        </div>

    </Layout>)

}

export default SupervisorUpdate